<script setup>
import { ref } from 'vue'
import { Copy } from '@lucide/vue'

import { useCopy } from './audit-copy.js'
import { pretty, useAuditText } from './audit-text.js'

// JSON 只在原始数据页签出现；其他页签一律按字段或文本渲染。
defineProps({
  label: { type: String, required: true },
  value: { type: null, default: null },
  // 放进标题 title 的补充说明。
  note: { type: String, default: '' },
})

const { tr } = useAuditText()
const copy = useCopy()
// 完整作品内容与快照可能几百 KB，展开时才序列化进 DOM。
const open = ref(false)
</script>

<template>
  <details class="au-json" @toggle="open = $event.target.open">
    <summary :title="note || undefined">
      <span>{{ label }}</span>
      <button type="button" class="au-link-btn" @click.stop.prevent="copy(pretty(value))">
        <Copy :size="12" aria-hidden="true" /> {{ tr('copy') }}
      </button>
    </summary>
    <pre v-if="open" class="au-pre au-scroll">{{ pretty(value) }}</pre>
  </details>
</template>
